var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box"},[_c('div',{staticClass:"page-title-right"},[_c('b-breadcrumb',{staticClass:"m-0",attrs:{"items":_vm.items}})],1),_c('h4',{staticClass:"page-title",domProps:{"innerHTML":_vm._s(_vm.title)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }